import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import classnames from "classnames";
import { UI_THEME } from "utils/constants/ui";
import { COLORS } from "utils/styles";
import { gridContainer } from "constants/styles";

const FEATURES = {
  EDITOR: "editor",
  CUSTOMIZE: "customize",
  CHECKOUT: "checkout",
  PUBLISH: "publish"
};

const DOCS_GRID_CONFIG = [
  {
    id: FEATURES.CHECKOUT,
    label: "Hosting and delivery provided",
    description:
      "We'll host your content for you and deliver it to your customer through a secure download link after a successful payment."
  },
  {
    id: FEATURES.EDITOR,
    label: "No website required",
    description:
      "You can sell your digital content without needing to build a website."
  },
  {
    id: FEATURES.CHECKOUT,
    label: "Multiple upload sources",
    description: "Securely upload from your device, Google Drive, Box and more."
  },
  {
    id: FEATURES.CHECKOUT,
    label: "Security and Performance",
    description:
      "Policies and signatures are used to ensure your uploads are secure, and delivery is provided through a world class CDN."
  }
];

const FeatureGrid = () => {
  return (
    <div className="w-100">
      <div className="grid-container-2xl pt3">
        {DOCS_GRID_CONFIG.map(
          ({ Icon, label, description, callout, footer }, gridIx) => {
            return (
              <div className="w-100 pb3 pb0-ns" key={gridIx}>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row items-center w-100">
                    {Icon && <Icon size={20} color={COLORS.primary} />}
                    <div
                      className={classnames(
                        "f4 f3-l fw6 color-text--primary lh-title",
                        {
                          pl2: Icon
                        }
                      )}
                      style={{ marginTop: 2 }}
                    >
                      {label}
                    </div>
                  </div>
                  {callout && <Pill copy={callout} theme={UI_THEME.SLIM} />}
                </div>
                <div className="f5 f4-l lh-copy pt2 mt1 color-text--primary">
                  {description}
                </div>
                {footer}
              </div>
            );
          }
        )}
        <style jsx>{gridContainer}</style>
        <style jsx>{cellGrow}</style>
      </div>
    </div>
  );
};

export default FeatureGrid;
